export function LoadingSpinner() {
    return (
        <div className='container mx-auto flex min-h-[calc(100vh-200px)] items-center justify-center p-6'>
            <div className='text-center'>
                <div className='mx-auto h-32 w-32 animate-spin rounded-full border-b-2 border-gray-900'></div>
                <p className='mt-4 text-lg'>Cargando datos de facturación...</p>
            </div>
        </div>
    )
}
